/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Service this fee row applies to. Determines which group (entry / license) the row persists into.
 */
export type ServiceType = (typeof ServiceType)[keyof typeof ServiceType];

export const ServiceType = {
  ENTRY: "ENTRY",
  LICENSE: "LICENSE",
  BOOKING: "BOOKING",
} as const;
